'use client';

import { motion } from 'framer-motion';
import clsx from 'clsx';
import { toTopButtonStyle } from './to-top-button.style';
import { Icon } from '@/components/icons/svg-icons';


interface ToTopButtonProps {
	className: string;
	isVisible: boolean;
	onScrollToTop: () => void;
}

export const TargetToTopButton = ({
	className,
	onScrollToTop,
	isVisible
}: ToTopButtonProps) => {

	const goToTop = () => {
		onScrollToTop();
	};

	return (
		<motion.div 
			className={clsx('go-top-btn', className, toTopButtonStyle.root)}
			data-show={true}
			variants={{
				visible: { 
					opacity: 1,
					visibility: 'visible'
				},
				hidden: { 
					opacity: 0,
					visibility: 'hidden'
				}
			}}
			initial="hidden"
			animate={isVisible ? 'visible' : 'hidden'}
			onClick={goToTop}
		>
			<Icon name="go-to-top" />
		</motion.div>
	);
};